/* eslint-disable no-restricted-syntax -- 机器人吉祥物为固定装饰插画（移植自 ChatWidget），其配色为美术资源、非可换肤的品牌 token，故豁免 hex 规则 */
/** 机器人吉祥物配色（从 SupportDock.tsx 抽出，避免 TSX 内硬编码 hex；纯装饰插画色）。 */
export const ROBOT = {
  cyan: '#00D2FF',
  purple: '#6C5CE7',
  purpleDeep: '#4834d4',
  purpleMid: '#5541d8',
} as const;
